import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";

export function ResetToTriggeringSpinCommand() {
    const gameplay = GameState.getCurrentGame();

    SmartUIFlags.set(SmartUIFlag.FREE_SPINS, false);
    SmartUIFlags.set(SmartUIFlag.PROMPT, false);

    Services.transaction.setBalance(GameState.getCurrentGame().balance);

    gameplay.resetToRootRecord();

    Services.transaction.setWinnings(gameplay.getTotalWin()).execute();

    Components.matrix.clearStuckSymbols();
}
